import styled from "styled-components";

export const Form = styled.form`
  width: 100%;
  @media (max-width: 910px) {
    margin: 0 auto;
  }
`;
